import React from 'react';
import { Icon, IconProps } from './Icon';

export const MoveLeftIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 16 12" height="16" width="12" {...props}>
      <g transform="rotate(180 8 6)">
        <path
          d="M10.0833 1.41797L14.5606 5.89433C14.6313 5.96376 14.6666 6.05475 14.6666 6.14575M10.0833 10.5846L14.5606 6.39716C14.6313 6.32774 14.6666 6.23674 14.6666 6.14575M14.6666 6.14575H1.33325"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </Icon>
  );
};
